import React, { useState } from "react";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import {DialogContent, Grid, Dialog, DialogActions} from "@material-ui/core";
import Input from "Components/Input/Input";
import { ReactSVG } from "react-svg";
import crop from "Assets/svg/icon/Cuting_nv.svg";
import { useDispatch, useSelector } from "react-redux";
import { getKasriBoresh, UpdateKasriBoresh } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import * as R from "ramda";
import millimeterMask from "Components/Input/components/millimeterMask";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';
import showNotify from "Helpers/Notify";
import { useTheme } from '@material-ui/core/styles';

function KasriBoreshDialog() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { kasriBoreshData, selectedDasteProfile } = useSelector((state) => ({
    kasriBoreshData: state.profile.kasriBoreshData,
    selectedDasteProfile: state.profile.selectedDasteProfile,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [idGP, setIdGP] = useState(-1);
  const [openDialog, setOpenDialog] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [controls, setControls] = useState({});

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    try {
      setControls({});
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdGroupProfile: selectedDasteProfile.Id,
      };
      const data = await dispatch(getKasriBoresh(params));
      const inputs = {};
      const validation = {}
      data.map(item => {
        validation[item.IdStruct] = true;
        setIdGP(item.IdGroupProfile)
        inputs[item.NamePart] = {
          id: item.IdStruct,
          type: "number",
          value: item.LossCut,
          validation: {
            required: true,
            isNumeric: true,
          },
        }
      })
      setFormValid(validation);
      setControls(inputs);
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  }

  const setValue = (id, value, validation) => {
    const inputs = controls;
    Object.keys(inputs).map((key) => {
      if(inputs[key].id === id) {
        inputs[key].value = value;
      }
    })
    setControls(inputs);
    setFormValid({ ...formValid, [id]: validation });
  }

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!R.isEmpty(formValid) && Object.values(formValid).every((item) => item === true)) {
      try {
        const inputs = controls;
        const updateData = [];
        Object.keys(inputs).map((key) => {
          const newValue = +convertToEnglishNumber(inputs[key].value);
          const pervValue = kasriBoreshData.find(items => items.IdStruct === inputs[key].id)
          if(pervValue.LossCut !== newValue) {
            updateData.push({
              IdStruct: inputs[key].id,
              LossCut: +convertToEnglishNumber(inputs[key].value)
            })
          }
        })
        if(updateData.length !== 0) {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdGroupProfile: idGP,
            Data : updateData,
          };
          await dispatch(UpdateKasriBoresh(data));
          handleDialog();
        } else {
          handleDialog();
          // showNotify({
          //   text: t('noEditedItem'),
          //   customClass: "warning",
          // });
        }
      } catch (err) {
        console.error('[catch error]', err)
      }
    }
    setLoading(false);
  }

  const onExit = () => {
    setLoading(false);
    setOpenDialog(false);
    setFormValid({});
    setControls({});
  }

  return (
    <>
      <MuiIconButton
        title={<Translator id={"Reinforcement_cutting_decrease_setting"}/>}
        icon={<ReactSVG src={crop} />}
        onClick={handleDialog}
        className="fix-size"
        disabled={ selectedDasteProfile.Disable ||
        (selectedDasteProfile.IsG &&
            read("StypeU") !== "1") ||
            (selectedDasteProfile.IsG === false &&
            read("StypeU") !== "1" &&
            read("addSeriProfileRules")?.accessUpdate === false )
        }
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        TransitionProps={{
          onEnter: onEnter,
          onExit: onExit
        }}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p> <Translator id={"Reinforcement_cutting_decrease_setting"}/></p>
          </div>
          <DialogContent>
            {!loading ?
              <Grid container spacing={2}>
                {Object.keys(controls).map((key) => {
                  return (
                    <Grid key={key} item lg={3} sm={6} xs={12}>
                      <Input
                        setValue={setValue.bind(this)}
                        name={controls[key].id}
                        value={controls[key].value}
                        validation={controls[key].validation}
                        label={<span>{key}</span>}
                        placeholder={key}
                        type={controls[key].type}
                        endIcon={<Translator id='millimeter' />}
                        inputComponent={millimeterMask}
                      />
                    </Grid>
                  );
                })}
              </Grid> : <MuiSkeleton xs={6} number={6} />
            }
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
                disabled={loading}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
                disabled={loading}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default KasriBoreshDialog;
